<template>
<q-menu
    v-bind="$attrs"
    :offset="[-15,10]"
    :anchor="anchor"
    :self="anchorSelf"
    transition-show="jump-down"
    transition-hide="jump-up"
    class="actionable-menu"
    :auto-close="autoClose"
    @update:model-value="$emit('update:model-value', $event)"
    @hide="$emit('hide')"
>
  <q-list
      :separator="separator"
  >
    <slot />
  </q-list>
</q-menu>
</template>

<script>
export default {
  emits: ['hide', 'update:model-value'],
  props: {
    separator: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    anchor: {
      type: String,
      default: 'bottom right',
    },
    anchorSelf: {
      type: String,
      default: 'top right',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

